import React from 'react';
import Chip from 'ui/elements/Chip';

interface Props {
  label: string;
  className?: string;
  onDelete?: () => void;
  onClick?: () => void;
  fontSize?: 'small' | 'large';
}

export default function IndustryChip(props: Props) {
  return <Chip color="blue-light" onClick={props.onClick} {...props} />;
}
